import LevelBackgroundTilesLayer from "./level-layout/LevelBackgroundTilesLayer";
import { THEME_BACKGROUNDS } from "../helpers/consts";
import { LevelState } from "../classes/LevelState";
import { useEffect, useState } from "react";
import styles from "./RenderLevel.module.css";
import TopUI from "./top-ui/TopUI";
import ChangeLevelMenu from "./top-ui/ChangeLevelMenu";
import FailedPopupMessage from "./top-ui/FailedPopupMessage";
import CompletedMessage from "./top-ui/CompletedMessage";
import EditMapMenu from "./level-editing/EditMapMenu";
import LevelPlacementsLayer from "./level-layout/LevelPlacementsLayer";
import { useRecoilValue } from "recoil";
import { currentLevelSelector } from "../atoms/currentLevelAtom";
import SettingsMenu from "./top-ui/SettingsMenu";
import LevelCompletedTransition from "./level-layout/LevelCompletedTransition";
import MobileDpad from "./top-ui/MobileDpad";
import InGameTextbox from "./pixel-text/InGameTextbox";

export default function RenderLevel({ onBackToTitle, onGoToEndingScene }) {
  const [level, setLevel] = useState(null);
  const currentLevel = useRecoilValue(currentLevelSelector);

  useEffect(() => {
    //Create a new Level, subscribing to updates
    const levelInstance = new LevelState(currentLevel, (emittedState) => {
      // Updates will continue to setState
      setLevel(emittedState);
    });

    //Initial State
    setLevel(levelInstance.getState());

    // Unsubscribe and unbind when we unmount (React 18 in local mode)
    return () => {
      levelInstance.destroy();
    };
  }, [currentLevel]);

  if (!level) {
    return null;
  }

  return (
    <div
      className={styles.fullScreenContainer}
      style={{
        background: THEME_BACKGROUNDS[level.theme],
      }}
    >
      <div className={styles.gameScreen}>
        <div
          style={{
            transform: `translate(${level.cameraTransformX}, ${level.cameraTransformY})`,
          }}
        >
          <LevelBackgroundTilesLayer level={level} />
          <LevelPlacementsLayer level={level} />
        </div>
        {/* Hero Death / RenderLevel Complete messages */}
        {level.heroDeath && (
          <div className={styles.failMessageContainer}>
            <FailedPopupMessage level={level} />
          </div>
        )}
        {level.isLevelCompleted && (
          <div className={styles.successMessageContainer}>
            <CompletedMessage level={level} />
          </div>
        )}
      </div>
      {/*<CameraValue hero={level.heroRef} />*/}

      {/* UI in top left and top right of screen */}
      <TopUI level={level} />
      {/* Various Modals that appear */}
      <EditMapMenu level={level} />
      <ChangeLevelMenu onBackToTitle={onBackToTitle} />
      <SettingsMenu />
      <LevelCompletedTransition
        level={level}
        onGoToEndingScene={onGoToEndingScene}
      />
      <MobileDpad level={level} />

      {level.story && <InGameTextbox level={level} />}
    </div>
  );
}
